<template>
    <div>
        <div class="banner inner">
            <img v-if="$store.state.user.banner.banner2" style="width:100%;" :src="$store.state.user.banner.banner2" alt="banner">
        </div>
        <div class="content">
            <div class="inner">
                <div class="teacher_list">
                    <div class="teacher_item" v-for="(item,index) in teacherList" :key="index">
                        <div class="item_inner">
                            <el-image
                                style="width: 253px; height: 253px;display:block;margin:0 auto;border-radius:50%;"
                                :src="item.teacherPic"
                                lazy
                                fit="cover"></el-image>
                            <div class="teacher_info">
                                <div class="name">{{item.teacherName}}</div>
                                <div class="synopsis" :title="item.teacherContent">{{wordlimit(item.teacherContent,143)}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {getTeacherList} from '@/api/home'
export default {
    name:"TeacherStyle",
    data(){
        return {
            teacherList:[]
        }
    },
    created(){
        this.getTeacherList()
    },
    methods:{
        getTeacherList(){
            getTeacherList().then(res=>{
                console.log(res)
                if(res.code==200){
                    this.teacherList = res.rows
                }
            })
        },
        getBlength(str) {
            for (var i = str.length, n = 0; i--; ) {
                n += str.charCodeAt(i) > 255 ? 2 : 1;
            }
            return n;
        },
        cutByte(str, len, endstr) {
            var len = +len,
            endstr = typeof(endstr) == 'undefined' ? "..." : endstr.toString(),
            endstrBl = this.getBlength(endstr);
            function n2(a) {var n = a / 2 | 0; return (n > 0 ? n : 1)}//用于二分法查找
            if (!(str + "").length || !len || len <= 0) {
                return "";
            }
            if(len<endstrBl){
                endstr = "";
                endstrBl = 0;
            }
            var lenS = len - endstrBl,
            _lenS = 0,
            _strl = 0;
            while (_strl <= lenS) {
                var _lenS1 = n2(lenS - _strl),
                addn = this.getBlength(str.substr(_lenS, _lenS1));
                if (addn == 0) {return str;}
                _strl += addn
                _lenS += _lenS1
            }
            if(str.length - _lenS > endstrBl || this.getBlength(str.substring(_lenS-1))>endstrBl){
                return str.substr(0, _lenS - 1) + endstr
            }else{
                return str;
            }
        },
        wordlimit(text, wordlength) {
            // 判断字符串字节数是否小于等于wordlength，小于等于就不用截取，直接显示，大于wordlength就截取
            if (this.getBlength(text) <= wordlength) {
                return text;
            } else {
                // 截取指定长度的字符串
                var result = this.cutByte(text, wordlength, '');
                // alert(result);
                return result + '...';
            }　　　　
        }
    }
}
</script>
<style lang="scss" scoped>
.content{
    margin: 100px 0 180px;
}
.teacher_list{
    margin-left: -30px;
    margin-right: -30px;
    display: flex;
    flex-wrap: wrap;
    .teacher_item{
        width: 33.33%;
        padding: 0 30px;
        color: #333333;
        margin-bottom: 100px;
        
        .item_inner{
            border: 1px solid #B2B2B2;
            background: #fff;
            padding: 50px 0 0;
        }
        .teacher_info{
            padding: 0 31px;
            text-align: center;
        }
        .name{
            font-size: 26px;
            line-height: 1;
            font-weight: 800;
            margin: 39px 0 34px;
        }
        .synopsis{
            font-size: 15px;
            font-weight: 500;
            line-height: 1.5;
            height: 110px;
            overflow: hidden;
        }
    }
}
</style>